import { render, staticRenderFns } from "./TeacherItem.vue?vue&type=template&id=0769f698&"
import script from "./TeacherItem.vue?vue&type=script&lang=js&"
export * from "./TeacherItem.vue?vue&type=script&lang=js&"
import style0 from "./TeacherItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports